import { INTERNSHIP_STUDENT_OPTIONS, OperationType, ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";
import { MetaModel } from "common/models/utility-models/base-model";
import { StudentFilterModel } from "../../internship/studentlist/student-filter-model";
import { InternshipFilterMetaModel } from "../Intership Filter Form/internship-list-filter-meta.model";


export class InternshipListGridMetaModel extends GridMetaModel<Headers> {
    filterMeta = new InternshipFilterMetaModel().getMetaModel();
    constructor() {
        super(
            'Internship Students List',
            ROUTE_PATH.intershipGrid,
            ROUTE_PATH.internship,
            false,
            false,
            10,
            true,
            false,
            ['orgname'],
            false,
            [],
            {
                isDownloadExcel: true, excelFileName: 'Intership_student_list' + new Date().toLocaleDateString() + '.xlsx', btnLabel: 'Download List',
                headers: [
                    { key: 'Full_Name', value: 'orgname' },
                    { key: 'E_Mail', value: 'orgemail' },
                    { key: 'Contact', value: 'orgmobile' },
                    { key: 'State', value: 'state_name' },
                    { key: 'Internship_Title', value: 'internshipTitle' },
                    { key: 'Internship_Company', value: 'companyName' },
                    { key: 'Location', value: 'district' },
                    { key: 'Mentor_Name', value: 'mentorName' },
                    { key: 'Status', value: 'OverallStatus' },
                    { key: 'Gender', value: 'orggender' },
                    { key: 'College_Name', value: 'name_of_college' },
                    { key: 'Branch', value: 'branchName' },
                    { key: 'Batch', value: 'batch_number' },
                    { key: 'Region', value: 'region' },
                    { key: 'First_Semester', value: 'first_year_score' },
                    { key: 'Second_Semester', value: 'second_year_score' },
                    { key: 'Third_Semester', value: 'third_year_score' },
                    { key: 'Fourth_Semester', value: 'fourth_year_score' },
                    { key: 'Fifth_Semester', value: 'fifth_year_score' },
                    { key: 'Sixth_Semester', value: 'first_year2_score' },
                    { key: 'Seventh_Semester', value: 'second_year2_score' },
                    { key: 'Eight_Semester', value: 'third_year2_score' },
                    { key: 'Nineth_Semester', value: 'fourth_year2_score' },
                    { key: 'Tenth_Semester', value: 'fifth_year2_score' },
                ],
            },
            false,
            null,
            false,
            true,
            null,
            null,
            { evalKey: 'OverallStatus', evalParam: ['Assigned'], decisiveParam: true },
            null,
            null,
            {
                isPreview: true,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            false,
            true,
            true,
            [],
            false,
            {
                isExtraActions: true,
                btnLabel: '',
                selectOptions: INTERNSHIP_STUDENT_OPTIONS,
                selectedValue: '0',
            },
            { isCheckboxEmit: true, emitKey: 'id', checkedKey: '', valueKey: '' },
            {
                isDownload: false,
                key: '',
                valueKey: '',
            },
            {
                isTabStatus: false,
                label: '',
                isChecked: false,
            }, false, false, {
            isPrimary: true,
            isDanger: false,
        }, '', { value: '', isVisible: false }, false, false, true, {
            isExtraActions: false,
            btnLabel: '',
            selectOptions: [],
            selectedValue: '',
            isPreviewBtn: false,
            previewBtnLabel: '',
        }, { value: '', isVisible: false }, false, null, {
            isExtraActions: true,
            btnLabel: 'Un-Assign Student',
            selectOptions: [],
            selectedValue: '',
            isPreviewBtn: false,
            previewBtnLabel: 'Un-Assign Student',
        }
        );
    }


    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const orgname = new Headers('Full Name', 'orgname', true, true, 'text', '0',);
        const orgemail = new Headers('E-Mail', 'orgemail', false, true, 'textUrl');
        const internshipTitle = new Headers('Internship Title ', 'internshipTitle', true, true, 'text');
        const companyName = new Headers('Internship Company ', 'companyName', true, true, 'text');
        const locName = new Headers('Location', 'locName', false, true, 'text');
        const mentorName = new Headers('Mentor Name', 'mentorName', false, true, 'text');
        const OverallStatus = new Headers('Status', 'OverallStatus', true, true, 'text', '0',)
        const internshipMasterId = new Headers('', 'internshipMasterId', false, false, "");
        const preview = new Headers(
            '',
            'preview',
            false,
            true,
            'redirect',
            '0',
            {
                isColumnNavigation: true,
                navigationUrl: ROUTE_PATH.studentInternshipAvailabilityDetails,
                navigateOperationType: OperationType.UPDATE,
                navigateTransferData: {},
            },
            null,
            {
                isToggle: false,
                toggleKey: '',
                toggleCheckedValue: '',
                toggleUncheckedValue: '',
            },
            true
        );

        headers.push(orgname);
        headers.push(orgemail);
        headers.push(internshipTitle);
        headers.push(companyName);
        headers.push(locName);
        headers.push(mentorName);
        headers.push(OverallStatus);
        headers.push(internshipMasterId);
        headers.push(preview);
        return headers;
    }

    override getMetaModel(): MetaModel {
        const pageData = new MetaModel();
        pageData.pageTitle = this.pageTitle;
        pageData.properties = this.initProperties();
        pageData.redirectPath = this.redirectPath;
        pageData['filterMeta'] = this.filterMeta;
        return pageData;
    }
}